/**
 * The destructive / short action — close, cancel, sell.
 *
 * `.ce-btn-down` is the semantic down gradient plus its own red shadow
 * (neumorph2026.css §3).
 */
export const RedButton = ({ text, onClick = () => {}, className = "" }) => {
  return (
    <button type="button" onClick={onClick} className={`ce-btn ce-btn-down ${className}`.trim()}>
      {text}
    </button>
  );
};
